import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "tph_flights_price_discrepancy_aa",
    defaultStage: 2,
    stages: {
        all_logged_in_from_wishlist: 2,
        web_logged_in_from_wishlist: 8
    },
    goals: {
        flight_details_price_loaded: 2,
        price_match: 3,
        price_mismatch_wishlist_higher: 4,
        price_mismatch_wishlist_lower: 5
    },
    goalsWithValue: [
        "tph_flights_price_match_count",
        "tph_flights_price_mismatch_wishlist_higher_count",
        "tph_flights_price_mismatch_wishlist_lower_count"
    ]
});
export default utils;
